import { useSelector } from 'react-redux';
import LensItem from './LensItem';

function LensList() {
    const lensInsights = useSelector((state) => state.reportAnalysis.lensInsights.lensInsights);

    return (
        <div className='mt-3 mx-5'>
            <div className="flex bg-[#F5F5F5] text-[14px] leading-6 font-semibold text-[#666666]">
                <h2 className="w-[48%] px-[10px] py-[8px] uppercase">content</h2>
                <h2 className="w-[13%] px-[10px] py-[8px] uppercase">reach</h2>
                <h2 className="w-[13%] px-[10px] py-[8px] uppercase">likes</h2>
                <h2 className="w-[13%] px-[10px] py-[8px] uppercase">comments</h2>
                <h2 className="w-[13%] px-[10px] py-[8px] uppercase">purchase</h2>
            </div>

            <div className="flex flex-col">
                {
                    lensInsights.lensList.map(item => {
                        return (
                            <LensItem 
                                item={item} 
                                key={item.id} 
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default LensList;
